// removed by extract-text-webpack-plugin
module.exports = {"headerBox":"_2d33u5jMZhZWqHkrIeHGjB","header":"_2xPSohp02uNSI1gAopQz5V","right":"_1OkMFrxGliMrs7S6BYrFMa","seeMore":"_2HLZvDg5eDzJKJRjS-HH1O","arrowRight":"_2wbsLF1_G1hMYLXD02qGWZ","imgPersonal":"_3Py7ioWD-7_ab6eYt2qbK8","left":"_3ZNW-3GcvG1srcgAS5N_nd","title":"_1efEaYidOVDPREEkJZjUl5","slogan":"_2csLekBeNYa9I1P41vpg5g","personal":"_283tUs3ku69AwukVo9jRtO","collectionList":"_1NCtgqrUzI1nbMsy1yQkHH","onlyOne":"_3CdJuW0WHYazXTImsJMF1L","item":"_1Neuls-5fQqQMn9n9uQoIM"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Home/SectionPersonal.scss
// module id = 1144
// module chunks = 0